import { NavLink, Outlet, useParams, Link } from 'react-router-dom';
import { TurfDataProvider, useTurfData } from '../data/TurfDataProvider';
import { PendingBadge } from '../components/PendingBadge';

function Chrome() {
  const { turf, loading, error, readOnly, reload } = useTurfData();

  return (
    <div className="turf-shell">
      <header className="turf-shell__head">
        {/* Back to where this was opened from. An organizer reading turf that
            is not theirs came from the organize map, and sending them to a
            turf list they have no rows in is a dead end. */}
        <Link
          className="back"
          to={readOnly ? '/organize' : '/turfs'}
          aria-label={readOnly ? 'Back to the organize map' : 'Back to turf list'}
        >
          ‹
        </Link>
        <h1>{turf?.name ?? (loading ? 'Loading…' : 'Turf')}</h1>
        {readOnly ? <span className="chip chip--read">Read-only</span> : <PendingBadge />}
      </header>

      {error ? (
        <p className="banner banner--error">
          {error}{' '}
          <button className="btn btn--link" onClick={reload}>
            Try again
          </button>
        </p>
      ) : null}

      <div className="turf-shell__body">
        <Outlet />
      </div>

      <nav className="tabs">
        <NavLink end to="." className={({ isActive }) => (isActive ? 'tab tab--on' : 'tab')}>
          Map
        </NavLink>
        <NavLink to="list" className={({ isActive }) => (isActive ? 'tab tab--on' : 'tab')}>
          List
        </NavLink>
      </nav>
    </div>
  );
}

export function TurfLayout() {
  const { turfId } = useParams<{ turfId: string }>();
  if (!turfId) return <p className="banner banner--error">No turf selected.</p>;

  return (
    <TurfDataProvider turfId={turfId}>
      <Chrome />
    </TurfDataProvider>
  );
}
